<div cdkTrapFocus aria-live="assertive">
  <div class="modal-header">
    <h3 class="modal-title" i18n="@@requiresReasonTitle" id="modal-header">Requires Reason</h3>
  </div>
  <div class="modal-body">
    <form [formGroup]="form">
      @for (item of form.controls | keyvalue; track item; let index = $index) {
        @if (
          {
            basketItems: getBasketItem | memoize: item.key,
            mi: getMI | memoize: item.key
          };
          as data
        ) {
          @if (data.mi) {
            <div [ngClass]="{ hide: splitCheck(index) }">
              <label for="reason-input-{{ index }}">{{ data.mi.managementInfo.name }}</label>
              @if (data) {
                <section class="container" (mouseleave)="tt1.close()">
                  <i
                    class="ico-info"
                    [ngbTooltip]="data.mi.managementInfo?.description"
                    tabindex="0"
                    triggers="manual"
                    #tt1="ngbTooltip"
                    (mouseenter)="tt1.open()"
                    (focus)="tt1.open()"
                    (blur)="tt1.close()"
                  ></i>
                </section>
              }
              <select
                [formControlName]="data.mi.managementInfo.id"
                (change)="validate()"
                id="reason-input-{{ index }}"
                [ngbAutoFocus]="index === 0"
                appSelect
                [border]="true"
                [noIcon]="true"
              >
                @for (opt of data.mi.managementInfo.availableValues; track opt) {
                  <option [value]="opt.id">
                    {{ opt.label }}
                  </option>
                }
              </select>
            </div>
          }
        }
      }
    </form>
  </div>
  <div class="modal-footer">
    <button
      type="submit"
      id="requires reason cancel button"
      aria-labelledby="cancel and remove basket item"
      appButton="small"
      (click)="cancel()"
      (keydown.enter)="cancel()"
      (keydown.space)="cancel()"
      i18n-aria-label
      i18n="@@requiresReasonCancel"
    >
      Cancel
    </button>
    <button
      type="submit"
      [disabled]="!valid()"
      aria-labelledby="selected reason and continue"
      appButton="small"
      (click)="ok()"
      (keydown.enter)="ok()"
      (keydown.space)="ok()"
      i18n-aria-label
      i18n="@@requiresReasonModalOk"
    >
      Ok
    </button>
  </div>
</div>
